import React, {Component} from 'react';
import './App.css';

class Home extends Component {

  constructor(props){
    super(props);
    this.state = {test:""}
  }

  render(){
    return (
      <div className="Appp">
    
      </div>
    );
  }

}

export default Home;
